var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PdfButton } from '@hn-ui/reports';
import { Tooltip } from '@hn-ui/tooltips';
var initialTooltipProps = {
    content: 'Upon clicking this button, your browser will initiate the download of a PDF file.',
    maxWidth: '320px',
};
var PdfButtonWithTooltip = function (_a) {
    var _b = _a.tooltip, tooltip = _b === void 0 ? initialTooltipProps : _b, rest = __rest(_a, ["tooltip"]);
    return (_jsx(Tooltip, __assign({}, tooltip, { children: _jsx(PdfButton, __assign({}, rest), void 0) }), void 0));
};
export { PdfButtonWithTooltip };
